import hsFetch from 'hellospa/hs-fetch';

export type DisconnectHSBody = {
    SPSiteUrl: string,
    SPAppToken: string,
    removeTeamMembers?: boolean,
};

export type DisconnectHSResponse = {
    success: boolean,
    error?: string,
};

export default function sharepointActions() {

  async function disconnectHS(body: DisconnectHSBody) : Promise<DisconnectHSResponse> {
    try {

      const response = await hsFetch('/sharepoint/disconnect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${body.SPAppToken}`,
        },
        body: JSON.stringify(body),
      });

      const resp = await response.json();

      return {
        success: resp.success,
      } as DisconnectHSResponse;

    } catch (error) {
      return {
        success: false,
        errorMsg: error,
      } as DisconnectHSResponse;
    }
  }

  return {
    disconnectHS,
  };
}
